import { userConstants } from "../../constant";

export function sentMessage(state = [], action) {
  switch (action.type) {
    case userConstants.SEND_MY_MESSAGE:
      return {
        message: action.message,
      };
    case userConstants.CLEAR_MY_MESSAGE:
      return [];
    default:
      return state;
  }
}
